import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import WorkSheet from '../../../../components/modules/report/work-sheet';
import WorkSheetMiddleware from '../../../../middleware/modules/report/work-sheet';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,workSheet }) => ({
  isProcessing: workSheet.isProcessing,
  isError: workSheet.isError,
  errorMessage: workSheet.errorMessage,
  datalist:workSheet.data,
  showModal:workSheet.showModal,
  helperList:workSheet.helperWorkSheet
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:()=>WorkSheetMiddleware.getHelper(),
    reset: () =>WorkSheetMiddleware.resetList(),
    setData: (data) =>WorkSheetMiddleware.list(data),
    excel: (data) =>WorkSheetMiddleware.showExcel(data),
  }, dispatch);
};
class WorkSheetContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.any,
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
  }

  submitItem() {
    this.props.setData();
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.getHelper()
  
  }

  render() {
    const {datalist} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Work Sheet Report")}
          </title>
        </Helmet>
      <WorkSheet
        {...this.props}
        data={datalist}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkSheetContainer);
